import React, {
  useEffect,
  useState,
  forwardRef,
  ForwardRefRenderFunction,
} from "react";
import { Input } from "sr/helpers";
import { useIntl } from "react-intl";
import { useFormik } from "formik";
import reference from "sr/utils/schemas/cleaner/reference";
import { FormattedMessage } from "react-intl";
import { createReference } from "sr/utils/api/cleaner/createReference";
import { RadioInput } from "sr/helpers/ui-components/RadioInput";
import { getUserDetails } from "sr/helpers/functions/getUserDetails";
import { getReference } from "sr/utils/api/cleaner/getReference";
import { updateReference } from "sr/utils/api/cleaner/updateReference";
import { CleanerComponentProps } from "./CleanerComponentProps";
import ContentWithSpinner from "sr/layout/common/ContentWithSpiner";
import { ButtonAuth } from "sr/helpers/ui-components/ButtonAuth";
import { InputNumberFormat } from "sr/helpers/functions/InputNumberFormat";
import { LoaderFullScreen } from "sr/layout/common/LoaderFullScreen";
import PhoneNumberFormat from "sr/helpers/functions/PhoneNumberFormat";
import { renderRequiredLabel } from "sr/utils/helper";
import { deleteReference } from "sr/utils/api/cleaner/deleteReference";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencil, faTrash, faXmark } from "@fortawesome/free-solid-svg-icons";
const CleanerReference: ForwardRefRenderFunction<any, CleanerComponentProps> = (
  {
    HandleStepper = null,
    page = "",
    type = "",
    dataAddedHandle = null,
    id = "",
  },
  ref
) => {
  const [AddMoreClicked, setAddMoreClicked] = useState(false);
  const [firstName, setfirstName] = useState("");
  const [lastName, setlastName] = useState("");
  const [email, setEmail] = useState("");
  const [mobileNo, setMobileNo] = useState("");
  const [userData, setUserData] = useState(null);
  const [loader, setLoader] = useState(false);
  const [buttonLoader, setButtonLoader] = useState(false);
  const [data, setData] = useState([]);
  const [editingReferenceId, setEditingReferenceId] = useState("");
  useEffect(() => {
    const getdetails = getUserDetails();
    setUserData(getdetails);
  }, []);
  const initialValues = {
    cleaner_id: userData?.user_id,
    first_name: firstName,
    last_name: lastName,
    email: email,
    mobile_number: mobileNo,
  };
  const initialValuesPut = {
    cleaner_id: userData?.user_id,
    first_name: firstName,
    last_name: lastName,
    email: email,
    mobile_number: mobileNo,
    id: id,
  };

  useEffect(() => {
    const fetchData = async () => {
      setLoader(true);
      try {
        const referenceData = await getReference(undefined, id);
        if (referenceData.success === true) {
          setfirstName(referenceData?.data?.first_name);
          setlastName(referenceData?.data?.last_name);
          setEmail(referenceData?.data?.email);
          setMobileNo(referenceData?.data?.mobile_number);
          setFieldValue("id", id);
          setLoader(false);
        }
      } catch (e: any) {
      } finally {
        setLoader(false);
      }
    };
    if (page === "popup" && type === "put") {
      fetchData();
    }
  }, [id]);

  useEffect(() => {}, []);

  const intl = useIntl();
  const firstNameLabel = renderRequiredLabel(
    intl.formatMessage({
      id: "CLEANER.PROFILE.REFERENCE.INPUT.FIRSTNAME",
      defaultMessage: "Reference First Name",
    })
  );
  const lastNameLabel = renderRequiredLabel(
    intl.formatMessage({
      id: "CLEANER.PROFILE.REFERENCE.INPUT.LASTNAME",
      defaultMessage: "Reference Last Name",
    })
  );
  const emailLabel = renderRequiredLabel(
    intl.formatMessage({
      id: "CLEANER.PROFILE.REFERENCE.INPUT.EMAIL",
      defaultMessage: "Reference Email Address",
    })
  );
  const mobileNumberLabel = renderRequiredLabel(
    intl.formatMessage({
      id: "CLEANER.PROFILE.REFERENCE.INPUT.MOBILE",
      defaultMessage: "Reference Mobile Number",
    })
  );
  const resetReferenceForm = () => {
    setEditingReferenceId("");
    setfirstName("");
    setlastName("");
    setMobileNo("");
    setEmail("");
  };

  const { handleSubmit, errors, submitForm, setFieldValue } = useFormik({
    enableReinitialize: true,
    initialValues:
      page === "popup" && type === "put" ? initialValuesPut : initialValues,
    validationSchema: reference,

    onSubmit: async (values, helpers) => {
      setButtonLoader(true);
      try {
        let result;
        const payload = {
          ...values,
          visible_to_employer: true,
        };
        if (page === "popup" && type === "put") {
          result = await updateReference(payload);
        } else if (editingReferenceId) {
          result = await updateReference({
            ...payload,
            id: editingReferenceId,
          });
        } else {
          result = await createReference(payload);
        }
        if (result.success === true) {
          setButtonLoader(false);
          if (page === "popup") {
            dataAddedHandle(true);
          }
          if (AddMoreClicked) {
            setfirstName("");
            setlastName("");
            setMobileNo("");
            setEmail("");
            helpers.resetForm();
            setAddMoreClicked(false);
            fetchReference(userData?.user_id);
          } else if (editingReferenceId) {
            resetReferenceForm();
            fetchReference(userData?.user_id);
          } else {
            if (HandleStepper !== null) {
              HandleStepper(3);
            }
          }
        }
      } catch (e: any) {
        setButtonLoader(false);
      }
    },
  });
  React.useImperativeHandle(ref, () => ({
    submitForm,
  }));
  const fetchReference = async (cleanerId) => {
    setButtonLoader(true);
    try {
      const referenceData = await getReference(cleanerId, undefined);
      if (referenceData?.success) {
        setButtonLoader(false);
        setData(referenceData.data);
      } else {
        setButtonLoader(false);
      }
    } catch (e: any) {
      setButtonLoader(false);
    }
  };
  useEffect(() => {
    if (userData?.user_id) {
      if (page !== "popup" && type !== "put") {
        fetchReference(userData?.user_id);
      }
    }
  }, [userData?.user_id]);

  const handleEditReference = (item) => {
    setEditingReferenceId(item?.id);
    setfirstName(item?.first_name || "");
    setlastName(item?.last_name || "");
    setEmail(item?.email || "");
    setMobileNo(item?.mobile_number || "");
    setAddMoreClicked(false);
  };

  const handleDeleteReference = async (item) => {
    if (!item?.id) return;

    setButtonLoader(true);
    const queryParams = new URLSearchParams();
    queryParams.append("id", item.id);
    const result = await deleteReference(queryParams);
    setButtonLoader(false);

    if (result?.success === true) {
      if (editingReferenceId === item.id) {
        resetReferenceForm();
      }
      fetchReference(userData?.user_id);
    }
  };

  return (
    <ContentWithSpinner loader={loader}>
      {buttonLoader && <LoaderFullScreen />}
      <form className="mt-5" onSubmit={handleSubmit}>
        <Input
          value={firstName}
          onChange={(e) => setfirstName(e.target.value)}
          label={firstNameLabel}
          type="text"
          placeholder={intl.formatMessage({
            id: "CLEANER.PROFILE.REFERENCE.INPUT.FIRSTNAME.PLACEHOLDER",
            defaultMessage: "Enter your reference first name",
          })}
          name="first_name"
          error={errors.first_name}
        ></Input>
        <Input
          value={lastName}
          onChange={(e) => setlastName(e.target.value)}
          label={lastNameLabel}
          type="text"
          placeholder={intl.formatMessage({
            id: "CLEANER.PROFILE.REFERENCE.INPUT.LASTNAME.PLACEHOLDER",
            defaultMessage: "Enter your reference last name",
          })}
          name="last_name"
          error={errors.last_name}
        />

        <Input
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          label={emailLabel}
          type="text"
          placeholder={intl.formatMessage({
            id: "CLEANER.PROFILE.REFERENCE.INPUT.EMAIL.PLACEHOLDER",
            defaultMessage: "Enter your reference email address",
          })}
          name="email"
          error={errors.email}
        />

        <Input
          onChange={(e) => setMobileNo(e.target.value)}
          label={mobileNumberLabel}
          type="text"
          placeholder={intl.formatMessage({
            id: "CLEANER.PROFILE.REFERENCE.INPUT.MOBILE.PLACEHOLDER",
            defaultMessage: "Enter your reference mobile number",
          })}
          name="mobile_number"
          error={errors.mobile_number}
          value={InputNumberFormat(mobileNo)}
        />
        {(page === "popup" && type === "add") || type === "put" ? (
          ""
        ) : (
          <>
            <div className="lg:mt-5 mt-2 lg:flex block lg:space-x-5 mx-auto max-w-44 lg:max-w-full">
              <ButtonAuth loader={buttonLoader}>
                {editingReferenceId ? (
                  "Update Reference"
                ) : (
                  <FormattedMessage
                    id="REGISTER.BUTTON.SAVEANDCONTINUE"
                    defaultMessage="Save and Continue"
                  />
                )}
              </ButtonAuth>

              {!editingReferenceId && (
                <ButtonAuth
                  loader={buttonLoader}
                  onClick={() => setAddMoreClicked(true)}
                >
                  Add More
                </ButtonAuth>
              )}

              {editingReferenceId && (
                <button
                  type="button"
                  className="lg:mt-5 mb-3 mt-3 flex h-10 w-32 items-center justify-center gap-2 rounded-full border border-gray-300 bg-white px-4 text-sm font-bold text-gray-700 hover:bg-gray-100"
                  onClick={resetReferenceForm}
                >
                  <FontAwesomeIcon icon={faXmark} />
                  Cancel
                </button>
              )}

              {!editingReferenceId && (
                <div
                  className="rounded-full text-center
                 bg-[#ff39b3] font-bold
                 p-2
                 text-white
                 w-44
                 cursor-pointer lg:mb-5 lg:mt-5 mb-3 mt-3
                 hover:bg-navy"
                  onClick={() => HandleStepper(3)}
                >
                  Skip
                </div>
              )}
            </div>
            {data?.length > 0 && (
              <div className="mt-6 overflow-hidden rounded-lg border border-gray-200 bg-white">
                <div className="grid grid-cols-[1fr_1fr_1.5fr_1.2fr_96px] bg-gray-50 px-3 py-2 text-[12px] font-bold uppercase text-gray-600">
                  <div>First Name</div>
                  <div>Last Name</div>
                  <div>Email</div>
                  <div>Mobile</div>
                  <div className="text-right">Actions</div>
                </div>
                {data?.map((item) => (
                  <div
                    key={item?.id}
                    className={`grid grid-cols-[1fr_1fr_1.5fr_1.2fr_96px] items-center border-t border-gray-100 px-3 py-3 text-[14px] font-medium text-gray-800 ${
                      editingReferenceId === item?.id ? "bg-blue-50" : ""
                    }`}
                  >
                    <div className="break-words pr-2">{item?.first_name || "-"}</div>
                    <div className="break-words pr-2">{item?.last_name || "-"}</div>
                    <div className="break-words pr-2">{item?.email || "-"}</div>
                    <div>{PhoneNumberFormat(item?.mobile_number) || "-"}</div>
                    <div className="flex justify-end gap-2">
                      <button
                        type="button"
                        className="flex h-8 w-8 items-center justify-center rounded-md border border-gray-200 text-[#0078ae] hover:bg-gray-50"
                        onClick={() => handleEditReference(item)}
                        title="Edit reference"
                      >
                        <FontAwesomeIcon icon={faPencil} />
                      </button>
                      <button
                        type="button"
                        className="flex h-8 w-8 items-center justify-center rounded-md border border-red-200 text-red-600 hover:bg-red-50"
                        onClick={() => handleDeleteReference(item)}
                        title="Delete reference"
                      >
                        <FontAwesomeIcon icon={faTrash} />
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </>
        )}
      </form>
    </ContentWithSpinner>
  );
};

export default forwardRef(CleanerReference);
